import React, { type FC } from 'react'

export const BorrowerInsuranceSavingsSimulator: FC = () => (
  <div className="py-8 [&>sup]:leading-auto" id="simulez-votre-economie" />
)
